import React from "react";
import { Col, Form as FormLayout, ToggleButton } from "react-bootstrap"
import CheckBoxInput from "../../../../Common/components/checkbox-input";
import SelectInput from "../../../../Common/components/select-input";
import TextInput from "../../../../Common/components/text-input";

export const SubscriptionModel = ({ model, setFieldValue, useDefaultModel }) => {
    return <>
        <div className="d-flex">
            {
                useDefaultModel
                    ? <div
                        className="text-primary cursor-pointer"
                        onClick={() => setFieldValue("useDefaultModel", false)}
                    >
                        + Edit Model
                    </div>
                    : <div
                        className="text-danger cursor-pointer ml-auto"
                        onClick={() => setFieldValue("useDefaultModel", true)}
                    >
                        - Discard Model
                    </div>
            }
        </div>
        {
            !useDefaultModel &&
            <>
                <FormLayout.Row className="mt-4">
                    <SelectInput
                        label="Auto Renew*"
                        name="model[autoRenew]"
                        options={[{ name: "Enabled", value: "ENABLED" }, { name: "Disabled", value: "DISABLED" }]}
                    />
                    <TextInput
                        label="Currency*"
                        name="model[currency]"
                        type="text"
                    />
                    <SelectInput
                        label="Payment Type*"
                        name="model[type]"
                        options={[{ name: "Prepaid", value: "PREPAID" }, { name: "Postpaid", value: "POSTPAID" }]}
                    />
                </FormLayout.Row>
                <FormLayout.Row>
                    <TextInput
                        label="Maximum Backlog (Months)*"
                        name="model[maxBacklog]"
                        type="number"
                    />
                    <TextInput
                        label="Free Subscription Trade Quota*"
                        name="model[tradeAbove]"
                        step="any"
                        type="number"
                    />
                </FormLayout.Row>
                <FormLayout.Row>
                    <Col>
                        <label className={"capitalize text-sm"}>Fee Type*</label>
                        <div className="d-flex">
                            {
                                ["Flat", "Percentage"].map((value) => (
                                    <ToggleButton
                                        key={value}
                                        id="model[feeType]"
                                        type="radio"
                                        name={value}
                                        value={value}
                                        variant={`outline-${model?.feeType === value ? "dark" : "secondary"}`}
                                        className={"mr-2 w-100"}
                                        checked={model?.feeType === value}
                                        onChange={(e) => setFieldValue("model[feeType]", e.currentTarget.value)}
                                    >
                                        {value}
                                    </ToggleButton>
                                ))
                            }
                        </div>
                    </Col>
                    {
                        model?.feeType === "Flat"
                            ? <TextInput
                                label="Flat Fee*"
                                name="model[flat]"
                                step="any"
                                type="number"
                            />
                            : <TextInput
                                label="Percentage*"
                                name="model[percent]"
                                step="any"
                                type="number"
                            />
                    }
                </FormLayout.Row>
                {
                    model?.feeType === "Percentage" &&
                    <FormLayout.Row>
                        <TextInput
                            label="Minimum Fee*"
                            name="model[min]"
                            step="any"
                            type="number"
                        />
                        <TextInput
                            label="Maximum Fee*"
                            name="model[max]"
                            step="any"
                            type="number"
                        />
                    </FormLayout.Row>
                }
                <FormLayout.Row>
                    <CheckBoxInput
                        name="model[trial]"
                    >
                        Enable Trial
                    </CheckBoxInput>
                </FormLayout.Row>
            </>
        }
    </>
}